import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { examsApi } from '../../services/api';

export interface LandingCta {
  to: string;
  label: string;
}

interface Days {
  lgs: number | null;
  yks: number | null;
}

/**
 * Sınav sayacı — sessiz tek cümle. /exams/countdown kimlik istemeyen bir uç;
 * çağrı başarısız olursa, sayılar geçmişte kalmışsa ya da hiç sayı yoksa
 * HİÇBİR ŞEY çizilmez (bozuk kutu, spinner, "0 gün" yok).
 */
function useExamDays(): Days | null {
  const [days, setDays] = useState<Days | null>(null);
  useEffect(() => {
    let alive = true;
    examsApi
      .countdown()
      .then((res) => {
        if (!alive) return;
        const pick = (n: unknown) => (typeof n === 'number' && Number.isFinite(n) && n > 0 ? n : null);
        const next = { lgs: pick(res.data?.LGS?.daysLeft), yks: pick(res.data?.YKS?.daysLeft) };
        setDays(next.lgs === null && next.yks === null ? null : next);
      })
      .catch(() => {
        if (alive) setDays(null);
      });
    return () => {
      alive = false;
    };
  }, []);
  return days;
}

const ExamCountdown: React.FC = () => {
  const days = useExamDays();
  if (!days) return null;
  return (
    <p className="lp-count">
      {days.lgs !== null && (
        <>
          LGS’ye <strong className="lp-display">{days.lgs}</strong>
        </>
      )}
      {days.lgs !== null && days.yks !== null && ', '}
      {days.yks !== null && (
        <>
          YKS’ye <strong className="lp-display">{days.yks}</strong>
        </>
      )}{' '}
      gün kaldı.
    </p>
  );
};

/**
 * Kapanış: iki öğretmen/öğrenci robotu zeminde (alt bilgi çizgisinde) duruyor.
 * Bu görselin tam boy olması sayfadaki tek yer; ayakları sayfanın tabanına basıyor.
 */
const ClosingCta: React.FC<{ cta: LandingCta; signedIn: boolean }> = ({ cta, signedIn }) => (
  <section className="lp-close" aria-labelledby="lp-close-title">
    <div className="lp-wrap lp-close__inner">
      <div className="lp-close__text">
        <h2 id="lp-close-title" className="lp-h2">
          {signedIn ? 'Kaldığın yerden devam et.' : 'Hazırsan başlayalım.'}
        </h2>
        <p className="lp-close__lead">
          {signedIn
            ? 'Oturumun açık. Panelinden devam edebilirsin.'
            : 'Giriş bilgilerini okulundan ya da kurumundan öğrenebilirsin.'}
        </p>
        <div className="lp-actions lp-actions--close">
          <Link to={cta.to} className="lp-btn lp-btn--primary">
            {cta.label}
          </Link>
        </div>
        {/* Hesabı olmayan ziyaretçi için: /deneme-sinavi-videolari giriş istemiyor
            (GET /public/deneme-books* kimlik doğrulamasız, sayfa kendisi de
            "ücretsiz izleyin" diyor) — bu cümle o gerçeğe dayanıyor. */}
        {!signedIn && (
          <p className="lp-close__free">
            Henüz hesabın yoksa da{' '}
            <Link to="/deneme-sinavi-videolari" className="lp-link">
              deneme sınavı videolarını
            </Link>{' '}
            giriş yapmadan ücretsiz izleyebilirsin.
          </p>
        )}
        <ExamCountdown />
      </div>
      <img
        className="lp-close__pair"
        src="/a-register-mascot.png"
        alt="Kravatlı öğretmen robot ile sırt çantalı öğrenci robot yan yana duruyor; ikisi de başparmağını kaldırıyor."
        width={1716}
        height={1904}
        loading="lazy"
        decoding="async"
        draggable={false}
      />
    </div>
  </section>
);

export default ClosingCta;
